
import {Link} from "react-router-dom";

import './ReportList.scss';

import { CgList, CgUserAdd } from 'react-icons/cg';
import { GiSandsOfTime } from 'react-icons/gi';
import { FaMoneyCheckAlt } from 'react-icons/fa';

import React, { useContext } from 'react';
import MyContext from '../MyContext.jsx';




const Reportlist = () => {
  const userDetails = useContext(MyContext);

  return (
    <div className="report_page_container">
      <div className="menu_container">
        <Link to="/myvisitreport" className="single_menu_container">
            <img className="company_logo"  src={window.project_path+"/dashboard/myvisit.png"} height="100px;" />
        </Link>
        <Link to="/myattendancereport" className="single_menu_container">
            <img className="company_logo"  src={window.project_path+"/dashboard/myattendance.png"} height="100px;" />
        </Link>
        
        <Link to="/salesreport" style={{ display:userDetails.user_details.category_sale_report?"grid":"none" }} className="single_menu_container" >
            <img className="company_logo"  src={window.project_path+"/dashboard/Sales_Report.png"} height="100px;" />
        </Link>
      
        
        <Link to="/dealerwisereport" style={{ display:userDetails.user_details.dealer_report?"grid":"none" }} className="single_menu_container">
            <img className="company_logo"  src={window.project_path+"/dashboard/dealer_Price_Report.png"} height="100px;" />
        </Link>

        <Link to="/salesorderreport" style={{ display:userDetails.user_details.so_report?"grid":"none" }} className="single_menu_container">
            <img className="company_logo"  src={window.project_path+"/dashboard/Sales_Order_Report.png"} height="100px;" />
        </Link>

        
        <Link to="/executivewisereport" style={{ display:userDetails.user_details.exe_report?"grid":"none" }} className="single_menu_container">
            <img className="company_logo"  src={window.project_path+"/dashboard/Executive_wise_Report.png"} height="100px;" />
        </Link>
       
        <Link to="/averagepricereport" style={{ display:userDetails.user_details.average_price_report?"grid":"none" }} className="single_menu_container">
            <img className="company_logo"  src={window.project_path+"/dashboard/Average_Price_Report.png"} height="100px;" />
        </Link>

        
        </div>
    </div>
  )
}

export default Reportlist;

